export default __webpack_public_path__ + "static/image-asset-2c6a8c810733bca0715dbe92cbb5e216.webp";